import isArray from 'lodash/isArray';

export default function patentFamilyFormatter(patentFamily, patentsToShow = 5) {
  const result = [];

  if (isArray(patentFamily)) {
    for (let i = 0; i < patentFamily.length; i += 1) {
      if (result.length === patentsToShow && patentFamily.length > patentsToShow) {
        result.push('...');
        break;
      }

      const { patentNo, kindCode } = patentFamily[i];
      if (patentNo && kindCode) {
        result.push(`${patentNo} ${kindCode}`);
      }
    }

    return result.join('; ');
  }
  return patentFamily;
}
